<template>
  <div>
    <v-card-text>
      <v-expansion-panels>
        <v-expansion-panel v-for="item in items" :key="item.Id">
          <v-expansion-panel-header @click="getAnswers(item.Id)">
            <v-row>
              <v-col class="popupHeadline" cols="12">
                <h5>{{ item.Question }}</h5>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row justify="center">
              <v-col cols="12" v-if="answers.length > 0">
                <div class="answer-container">
                  <!-- Sol ok -->
                  <div class="arrow text-center">
                    <v-btn
                      icon
                      variant="text"
                      @click="prevAnswer"
                      :disabled="currentIndex === 0"
                    >
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                  </div>

                  <!-- İçerik (Resim + Yazı) -->
                  <v-img
                    :src="currentAnswer?.FileUrl"
                    class="bg-grey-lighten-2 responsive-img answer-content"
                    width="100%"
                    contain
                  ></v-img>

                  <!-- Sağ ok -->
                  <div class="arrow text-center">
                    <v-btn
                      icon
                      variant="text"
                      @click="nextAnswer"
                      :disabled="currentIndex === answers.length - 1"
                    >
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </div>
                </div>
                <!-- Yazı -->
                <div class="answer-text mt-4">
                  {{ currentAnswer?.Text }}
                </div>
                <!-- Sayfa bilgisi -->
                <div class="text-center mt-2">
                  {{ currentIndex + 1 }} / {{ answers.length }}
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </div>
</template>

<script>
import UserGuideService from "../services/UserGuideService";

export default {
  data: () => ({
    items: [],
    answers: [],
    currentIndex: 0,
  }),
  computed: {
    currentAnswer() {
      return this.answers[this.currentIndex] || null;
    },
  },
  mounted() {
    this.getQuestions();
  },
  methods: {
    getQuestions() {
      this.$store.state.loadingStatus = true;
      UserGuideService.getAll()
        .then((res) => {
          this.items = res.data.Result;
        })
        .catch((error) => {
          window.showError(error);
        })
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    getAnswers(id) {
      this.$store.state.loadingStatus = true;
      UserGuideService.getAnswers(id)
        .then((res) => {
          this.answers = res.data.Result;
          this.currentIndex = 0; // yeni soru açıldığında ilk cevaptan başla
        })
        .catch((error) => {
          window.showError(error);
        })
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    nextAnswer() {
      if (this.currentIndex < this.answers.length - 1) {
        this.currentIndex++;
      }
    },
    prevAnswer() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
  },
};
</script>

<style>
.bg-active {
  background-color: #192e59;
}

.answer-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.arrow {
  flex: 1;
}

.answer-content {
  flex: 5;
  text-align: center;
}

.answer-text {
  text-align: left;
  white-space: pre-line; /* Satır sonlarını korur */
  font-size: 16px;
  line-height: 1.6;
}

.responsive-img {
  height: 200px; /* varsayılan */
}

@media (min-width: 960px) {
  .responsive-img {
    height: 400px; /* md ve üstü */
  }
}

@media (min-width: 1920px) {
  .responsive-img {
    height: 1000px; /* lg ve üstü */
  }
}
</style>
